import './ProgressBar.css';

export type ProgressBarProps = {
    /** 0–100 */
    value: number;
    /** If true, renders the numeric percentage label on the right */
    showLabel?: boolean;
    /** Optional aria-label for screen readers */
    ariaLabel?: string;
};

function clampPercent(v: number): number {
    if (!Number.isFinite(v)) return 0;
    return Math.max(0, Math.min(100, v));
}

function ProgressBar({ value, showLabel = false, ariaLabel }: ProgressBarProps) {
    const pct = clampPercent(value);
    return (
        <div
            className="ui-progress"
            role="progressbar"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={ariaLabel}
        >
            <div className="ui-progress__track">
                <div className="ui-progress__fill" style={{ width: `${pct}%` }} />
            </div>
            {showLabel && <span className="ui-progress__label">{Math.round(pct)}%</span>}
        </div>
    );
}

export default ProgressBar;
